<div class="relative w-full h-full" [class]="hStyleClass">
  <img
    [ngSrc]="
      logoFileName
        ? getUploadPath('logo', logoFileName)
        : variant === 'base'
          ? 'assets/images/logo/base.svg'
          : 'assets/images/logo/icon.svg'
    "
    alt="logo"
    fill
    priority
    style="object-fit: contain" />
</div>
